import { typo } from '@design-system/styles'
import { css } from '@emotion/react'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import { matchPath, useHistory } from 'react-router'
import { NavLink } from 'react-router-dom'

import commonRepo from '@/repository/common.repo'

type Props = {
  to: React.ComponentProps<NavLink>['to']
  matchUrl?: string
  onClick?: () => void
} & React.ComponentProps<NavLink>

function SideNavigationLink({ to, children: label, matchUrl, onClick, ...props }: Props) {
  const history = useHistory()
  const [isPressed, setPressed] = useState<boolean>(false)
  const lastTo = typeof to === 'function' ? to(commonRepo.router.location) : to
  const isTouchableDevice = isMobile || isTablet

  useEffect(() => {
    if (isPressed) {
      history.push(lastTo)
      setPressed(false)
    }
  }, [isPressed])

  const handleClickStart = (e) => {
    e.preventDefault()
    onClick?.()
    setPressed(true)
  }

  return (
    <NavLink
      data-testid={`navigation-${label}`}
      data-component={`${label}탭`}
      to={to}
      css={css(S.defaultStyle)}
      activeStyle={activeStyle}
      isActive={(match, location) => {
        const customMatch = matchPath(location.pathname, { path: matchUrl })
        return isPressed || (matchUrl ? !!customMatch : !!match)
      }}
      onTouchStart={isTouchableDevice ? handleClickStart : undefined}
      onMouseDown={!isTouchableDevice ? handleClickStart : undefined}
      {...props}
    >
      {label}
    </NavLink>
  )
}

const S = {
  defaultStyle: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 54px;
    ${typo.body01};
    color: var(--Colors-Gray-600);
  `,

  newLabel: css`
    position: absolute;
    top: 50%;
    right: -16px;
    transform: translateY(-50%);

    img {
      border-radius: var(--Radius-100);
    }
  `,
}

const activeStyle = {
  fontWeight: '700',
  color: 'var(--Colors-Gray-900)',
}

export default SideNavigationLink
